import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./App.scss";
import "@digdir/designsystemet-css/popover.css";
import "@digdir/designsystemet-css/alert.css";
import "@digdir/designsystemet-css/button.css";
import "@digdir/designsystemet-css/dialog.css";
import "@digdir/designsystemet-css/heading.css";
import "@digdir/designsystemet-css/input.css";
import "@digdir/designsystemet-css/label.css";
import "@digdir/designsystemet-css/paragraph.css";
import "@digdir/designsystemet-css/dropdown.css";
import "@digdir/designsystemet-css/field.css";
import "@digdir/designsystemet-css/fieldset.css";
import "@digdir/designsystemet-css/validation-message.css";
import "@digdir/designsystemet-css/togglegroup.css";
import "@digdir/designsystemet-css/card.css";
import "@digdir/designsystemet-css/details.css";
import "@digdir/designsystemet-css/chip.css";
import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { PermissionsProvider } from "@contexts/PermissionsContext";
import { ScreenModeProvider } from "@contexts/ScreenModeContext";
import AuthenticatedApp from "./AuthenticatedApp";
import UnauthenticatedApp from "./UnauthenticatedApp";
const App = ({ pca }) => {
    return (_jsx(MsalProvider, { instance: pca, children: _jsx(ScreenModeProvider, { children: _jsxs(PermissionsProvider, { children: [_jsx(AuthenticatedTemplate, { children: _jsx(AuthenticatedApp, {}) }), _jsx(UnauthenticatedTemplate, { children: _jsx(UnauthenticatedApp, {}) })] }) }) }));
};
export default App;
